import { render, staticRenderFns } from "./ManageGoalsTab.vue?vue&type=template&id=5062afe2&scoped=true&"
import script from "./ManageGoalsTab.vue?vue&type=script&lang=js&"
export * from "./ManageGoalsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5062afe2",
  null
  
)

export default component.exports